/* eslint-disable no-unused-vars */
import { Grid, Typography, Button, CircularProgress } from "@mui/material";
import PConfirm from "../../../components/pos/PConfirm";
import PDialog from "../../../components/pos/PDialog";
import PText from "../../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import { SyncUtils } from "../../../utils/SyncUtils";
import PSelect from "../../../components/pos/PSelect";
import PDatePicker from "../../../components/pos/PDatePicker";
import { StringUtils } from "../../../utils/StringUtils";

export default function FxRateCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState(translate("New FX Rate"));
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [rate, setRate] = useState("");
  const [rateError, setRateError] = useState("");
  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/
  const [sourceCurrencyOptions, setSourceCurrencyOptions] = useState([
    { name: "USD", id: "USD" },
    { name: "SAR", id: "SAR" },
    { name: "OMR", id: "OMR" },
  ]);
  const [sourceCurrency, setSourceCurrency] = useState(null);
  const [sourceCurrencyError, setSourceCurrencyError] = useState("");
  const [conversionRate, setConversionRate] = useState("");
  const [conversionRateError, setConversionRateError] = useState("");
  const [date, setDate] = useState("");
  const [dateError, setDateError] = useState("");
  const [isLoaderEnabled, setIsLoaderEnabled] = useState(false);
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");

  props.biRef.child = {
    showFxRateWindow: showFxRateWindow,
  };

  useEffect(() => { }, []);

  useEffect(() => {
    setSourceCurrencyError("");
  }, [sourceCurrency]);
  useEffect(() => {
    setConversionRateError("");
  }, [conversionRate]);
  useEffect(() => {
    setDateError("");
  }, [date]);

  function showFxRateWindow(fxRateId) {
    if (fxRateId == null) {
      resetFields();
      setMode("create");
      setOpenWindow(true);
      setWindowTitile("New FX Rate");
    } else {
      setWindowTitile("Edit FX Rate");
      setMode("edit");
      populateTax(fxRateId);
    }
  }
  async function populateTax(id) {
    {
      try {
        let { data } = await API.get("/api/v1/fxrate/" + id);
        setOrigObject(data);
        populateData(data);
        setOpenWindow(true);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          translate("Not able to retrive FX-Rate data from server")
        );
      }
    }
  }

  function populateData(bean) {
    setOrigObject(bean);
    setSourceCurrency({
      id: bean.sourceCurrencyCode,
      name: bean.sourceCurrencyCode,
    });
    setConversionRate(bean.conversionRate);
    setDate(bean.effectiveDate);
    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  function resetFields() {
    setOrigObject(null);
    setSourceCurrency(null);
    setConversionRate(null);
    setDate("");
    setSourceCurrencyError("");
    setConversionRateError("");
    setDateError("");
    /*CODEGEN_RESET_FIELDS ######## DO_NOT_REMOVE ###########*/
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Are You Sure"),
      message:
        translate("Are you sure to delete tax") +
        " :" +
        origObject.sourceCurrencyCode +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let result = await API.delete("/api/v1/fxrate/" + origObject.id);
        props.showMessage(
          "warning",
          translate("FX rate") +
          " " +
          origObject.sourceCurrencyCode +
          " " +
          translate("got Removed")
        );
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        props.showMessage("error", translate("Not able to Delete FX Rate"));
      }
    }
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function onSave() {
    if (validate()) {
      var payload = createPayload();
      try {
        showProgress(true, "Saving");
        let result = await API.post("/api/v1/fxrate", payload);
        props.showMessage("success", translate("Saved Successfully"));
        SyncUtils.requestSync(result.headers);
        props.onRefresh();
        setOpenWindow(false);
        showProgress(false, "Saving");
      } catch (err) {
        showProgress(false, "Saving");
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage("error", translate("Not able to Save FX Rate"));
        }
      }
    }
  }

  function showDetailedError(msg) {
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
      if (obj.field === "sourceCurrencyCode") {
        setSourceCurrencyError(obj.message);
      }
    }

    props.showMessage("error", msg.message);
  }

  function createPayload() {
    let saveObject = Object.create(null);
    saveObject["sourceCurrencyCode"] = sourceCurrency.id;
    saveObject["baseCurrencyCode"] = props.context.store.currency;
    saveObject["conversionRate"] = conversionRate;
    saveObject["effectiveDate"] = StringUtils.getIsoDate(date);
    /*CODEGEN_CREATE_PAYLOAD ######## DO_NOT_REMOVE ###########*/
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = origObject.id;
      saveObject["intVersion"] = origObject.intVersion;
    }
    return saveObject;
  }

  function validate() {
    let flag = true;
    if (!sourceCurrency) {
      setSourceCurrencyError(translate("Source currency is Required"));
      flag = false;
    }
    if (!conversionRate || conversionRate === "") {
      props.showMessage("error", translate("Conversion Rate is Required"));
      //setConversionRateError(translate("Conversion Rate is Required"));
      flag = false;
    }
    if (!date || date === "") {
      setDateError(translate("Date is Required"));
      flag = false;
    }
    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/

    return flag;
  }

  async function onFetchLatestExchangeRateClick() {
    setIsLoaderEnabled(true);
    try {
      let { data } = await API.get(
        "/api/v1/get/latest/exchange/rate/" +
        sourceCurrency.id +
        "/" +
        props.context.store.currency
      );
      props.showMessage(
        "success",
        translate("Latest exchange rate fetched successfully")
      );
      setConversionRate(data);
    } catch (err) {
      props.showMessage("error", translate(err.response.data));
    }
    setIsLoaderEnabled(false);
  }

  const content = (
    <div>
      <Grid container spacing={3}>
        <Grid item sm={12}>
          <table width="100%">
            <tbody>
              <tr>
                <td width="35%">
                  <Typography variant="body1">
                    {translate("Source Currency")}
                  </Typography>
                </td>
                <td>
                  <PSelect
                    options={sourceCurrencyOptions}
                    value={sourceCurrency}
                    errorMessage={sourceCurrencyError}
                    onChange={(event, newValue) => {
                      setSourceCurrency(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Base Currency")}
                  </Typography>
                </td>
                <td>
                  <PText
                    disabled
                    value={props.context.store.currency}
                  //onChange={(e) => setBaseCurrency(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Conversion Rate")}
                  </Typography>
                </td>
                <td>
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td width="46%">
                          <PText
                            value={conversionRate}
                            error={conversionRateError}
                            onChange={(e) => setConversionRate(e.target.value)}
                          ></PText>
                        </td>
                        <td width="54%">
                          <Button
                            onClick={onFetchLatestExchangeRateClick}
                            variant="contained"
                            color="primary"
                            disabled={isLoaderEnabled}
                          >
                            {translate("Fetch Latest")}
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Date")}</Typography>
                </td>
                <td>
                  <PDatePicker
                    //defaultValue="2020-08-23"
                    value={date}
                    error={dateError}
                    onChange={(value) => setDate(value)}
                  ></PDatePicker>
                </td>
              </tr>
              {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
            </tbody>
          </table>
        </Grid>
      </Grid>
    </div>
  );

  function isDataChanged() {
    /* if (mode === "create") {
      if (name || name != "") return true;
    }
    if (mode === "edit") {
      if (name !== origObject.name) return true;
    }*/
    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/
    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"xs"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          onDelete={onDelete}
          mode={mode}
          isDataChanged={isDataChanged}
        //isLoaderEnabled={isLoaderEnabled}
        ></PDialog>
      )}

      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
